import styled from 'styled-components';

export const StyledUserSettingsIcon = styled.div`
  .user-settings-icon {
    display: flex;
    align-items: center;
    position: relative;

    .anticon {
      &:first-child {
        margin-top: -6px;
        font-size: 32px;
        background-color: ${({ background }) => background};
      }

      &:last-child {
        position: absolute;
        right: -4px;
        bottom: -4px;
        font-size: 16px;
        margin-left: 5px;
        border-radius: 10px;
        color: ${({ theme }) => theme.colors.black};
        background-color: ${({ background }) => background};
        transform: rotate(0deg);
        transition:
          transform 0.3s ease,
          color 0.3s ease;
        transition-delay: 0.2s;
      }
    }

    &:hover {
      .anticon {
        &:first-child {
          color: ${({ theme }) => theme.colors.mainOrange};
        }

        &:last-child {
          transform: rotate(180deg);
          color: ${({ theme }) => theme.colors.mainOrange};
          transition-delay: 0s;
        }
      }
    }
  }
`;
